import * as React from 'react';
import { Image, FlatList, Text, View, StyleSheet, Platform, Pressable, useWindowDimensions } from 'react-native';
import * as AppUtilities from "../context/AppUtilities";
import * as AppConstants from "../context/AppConstants";
import { AppContext } from "../context/AppContext";
import { useSelector, useDispatch } from 'react-redux';
import { Divider } from 'react-native-paper';
import { SearchLauncher } from '../components/SearchLauncher';

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    padding: 20,
  },
  heading: {
    fontSize: 18,
    fontWeight: "bold",
  },
  label: {
    fontSize: 14,
    fontWeight: "bold",
    paddingRight: 5,
    flexWrap: "wrap",
  },
  labelPadLeft: {
    fontSize: 18,
    fontWeight: "bold",
    paddingLeft: 10,
    paddingTop: 5,
  },
  normal: {
    fontSize: 14,
    paddingRight: 10,
    flexWrap: "wrap",
    flex: 1,
  },
  divider: {
    marginVertical: 15,
  },
  line: {
    flexDirection: "row",
    marginBottom: 15,
    flexShrink: 1,
  },
  line2: {
    flexDirection: "row",
    marginBottom: 25,
    marginTop: 10,
    flexShrink: 1,
  },
  line3: {
    flexDirection: "row",
    marginBottom: 15,
    flexShrink: 1,
    paddingLeft: 10,
  },
  listItemStyle: {
    paddingLeft: 5,
  },
  listItemLeftIcon: {
    marginRight: 0,
  },
  mainList: {
    flexGrow: 0,
  },
  kittemListItem: {
    backgroundColor: "transparent",
  },
  link: {
    color: "#0000EE",
    textDecorationLine: "underline",
  },
  subtitle: {
    marginVertical: 20,
    fontWeight: "600",
    color: "#6f6f6f",
  },
  legendWrapper: {
    flexDirection: "row",
    alignItems: "center",
  },
  legendTitle: {
    fontWeight: "bold",
    paddingLeft: 5,
    paddingBottom: 2,
  },
  legendSubtitle: {
    paddingLeft: 5,
  },
  listWrapper: {
    flexGrow: 1,
    padding: 10,
  },
  searchWrapper: {
    padding: 10,
    paddingTop: 0,
    minHeight: 75,
    //maxHeight: 300,
  },
  descriptionWrapper: {
    paddingHorizontal: 10,
  },
});

export function AllProducts({ route, navigation }) {
  const { showPermanentSnack, hideSnack, showSpinner, hideSpinner } = React.useContext(AppContext);
  const [filteredProducts, setFilteredProducts] = React.useState(null);
  const { width, height } = useWindowDimensions();
  const dataFilter = useSelector((state) => state.dataFilter);

  async function load() {
    try {
      showSpinner();
      hideSnack();

      AppUtilities.info("AllProducts.load fetching");

      const response = await AppUtilities.fetchUnauthorized(
        "AllProducts.load",
        "/find_humane/api/products?" + AppUtilities.convertFilterHashToQueryParametersSorted(dataFilter),
        "GET",
      );

      if (response.body) {
        hideSpinner();
        setFilteredProducts(response.body.products);
      } else {
        throw new Error("Result body not found");
      }
    } catch (e) {
      showPermanentSnack(AppUtilities.getErrors(e), "Retry", load);
      hideSpinner();
      AppUtilities.handleException(e, "AllProducts.load");
    }
  }

  React.useEffect(() => {
    if (dataFilter) {
      load();
    }
  }, [dataFilter]);

  const renderItem = ({ item, index }) => {
    return AppUtilities.renderProductRow(item, index, width);
  };

  return (
    <FlatList
      style={styles.mainList}
      keyboardShouldPersistTaps="handled"
      contentContainerStyle={styles.listWrapper}
      getItemLayout={AppUtilities.productListItemLayout}
      data={
        filteredProducts && filteredProducts.length > 0 ?
            filteredProducts.map((product) => (
              AppUtilities.createItemRow(
                product,
                () => {
                  navigation.navigate(
                    AppConstants.SCREENS.PRODUCTS_ALL_DETAILS,
                    {
                      productid: product.id
                    }
                  );
                },
                (props) => (product.partiallyhumane ? <Image source={require('../../assets/circle-half-full-grey-25.png')} style={AppConstants.STYLES.image25x25} /> : null),
              )
            ))
          :
            [ { i: "-1", title: filteredProducts ? "No matches" : "Loading..." } ]
      }
      ItemSeparatorComponent={Divider}
      renderItem={renderItem}
      ListHeaderComponent={(
        <View style={{ padding: 10 }}>
          <SearchLauncher floating={false} hideSearchLocation={true} />
        </View>
      )}
    />
  );
}
